import { BUTTON_VARIANTS } from 'ui/button';
import {
  CREATE_CAMPAIGN_BTN_TEST_ID,
  EDIT_CAMPAIGN_BTN_TEST_ID,
  UPDATE_CAMPAIGN_BTN_TEST_ID,
} from './CampaignButton.constants';

export const getButtonProps = (
  isReadOnly: boolean,
  campaignId: number,
  isDisabled: boolean,
  setIsReadOnly: (val: boolean) => void,
  onPublish: () => void,
) => {
  const createCampaignProps = {
    text: 'Create campaign',
    props: {
      variant: BUTTON_VARIANTS.PRIMARY,
      'data-test': CREATE_CAMPAIGN_BTN_TEST_ID,
      isDisabled,
    },
  };
  const updateCampaignProps = {
    text: 'Update Campaign',
    props: {
      variant: BUTTON_VARIANTS.PRIMARY,
      'data-test': UPDATE_CAMPAIGN_BTN_TEST_ID,
      onClick: onPublish, // pass through the dispatcher for the upsert on campaign.
      isDisabled,
    },
  };
  const editCampaignProps = {
    text: 'Edit Campaign',
    props: {
      variant: BUTTON_VARIANTS.SECONDARY,
      'data-test': EDIT_CAMPAIGN_BTN_TEST_ID,
      onClick: () => setIsReadOnly(false), // override the onclick handler for the button when we need to 'edit' campaign
      isDisabled,
    },
  };
  if (isReadOnly) return editCampaignProps;
  if (campaignId) return updateCampaignProps;
  return createCampaignProps;
};
